<div style="display: flex;flex-direction: row; width: 100%; align-items: center; gap: 6px;">
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'textarea'">
            <textarea [(ngModel)]="value" [placeholder]="placeholderText" style="padding-top: 6px; font: inherit; width:100%;" cdkTextareaAutosize
                #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="rows" cdkAutosizeMaxRows="10" (keydown)="onKeydown($event)"></textarea>
        </ng-container>
        <ng-container *ngSwitchCase="'input'">
            <input [placeholder]="placeholderText" [(ngModel)]="value" style="width: 100%;" (keydown)="onKeydown($event)">
        </ng-container>
    </ng-container>
    <div style="cursor: pointer;" (click)="setEdit()">
        <i class="fa-duotone fa-check action-icon"></i>
    </div>
    <div style="margin-right: 12px; cursor: pointer;" (click)="cancelValue.emit()">
        <i class="fa-duotone fa-ban icon-alternate"></i>
    </div>
</div>